module.exports = __webpack_public_path__ + "static/media/welcome.51cf991a.png";